import { all } from 'redux-saga/effects'
import { accountsSagas } from './accounts/accounts.sagas'

export function * accountRootSaga () {
  // add saga entrypoints here
  // the entrypoints should then use fork to add all necessary watchers
  yield all([
    accountsSagas(),
  ])
}
